import React, { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate('/admin/login');
      closeMobileMenu();
    }
  };

  const publicNavItems = [
    { path: '/', label: '금융상품' },
    { path: '/notice', label: '공시정보' },
  ];

  const adminNavItems = [{ path: '/admin/dashboard', label: '대시보드' }];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold text-primary-600">ETN Platform</div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {publicNavItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `text-base font-medium transition-colors duration-200 ${
                    isActive
                      ? 'text-primary-600 border-b-2 border-primary-600 pb-1'
                      : 'text-secondary-700 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            {isAuthenticated ? (
              <>
                {adminNavItems.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `text-base font-medium transition-colors duration-200 ${
                        isActive
                          ? 'text-primary-600 border-b-2 border-primary-600 pb-1'
                          : 'text-secondary-700 hover:text-primary-600'
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 text-base font-medium text-secondary-700 hover:text-primary-600 transition-colors duration-200"
                >
                  <FaSignOutAlt />
                  <span>로그아웃</span>
                </button>
              </>
            ) : (
              <NavLink
                to="/admin/login"
                className={({ isActive }) =>
                  `text-base font-medium transition-colors duration-200 ${
                    isActive
                      ? 'text-primary-600 border-b-2 border-primary-600 pb-1'
                      : 'text-secondary-700 hover:text-primary-600'
                  }`
                }
              >
                관리자
              </NavLink>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden text-2xl text-secondary-700 hover:text-primary-600 focus:outline-none"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-secondary-200 animate-fadeIn">
            <nav className="flex flex-col space-y-4">
              {publicNavItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={({ isActive }) =>
                    `text-base font-medium py-2 px-4 rounded-lg transition-colors duration-200 ${
                      isActive
                        ? 'bg-primary-50 text-primary-600'
                        : 'text-secondary-700 hover:bg-secondary-50'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              {isAuthenticated ? (
                <>
                  {adminNavItems.map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      onClick={closeMobileMenu}
                      className={({ isActive }) =>
                        `text-base font-medium py-2 px-4 rounded-lg transition-colors duration-200 ${
                          isActive
                            ? 'bg-primary-50 text-primary-600'
                            : 'text-secondary-700 hover:bg-secondary-50'
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  ))}
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-2 text-base font-medium py-2 px-4 rounded-lg text-secondary-700 hover:bg-secondary-50 transition-colors duration-200"
                  >
                    <FaSignOutAlt />
                    <span>로그아웃</span>
                  </button>
                </>
              ) : (
                <NavLink
                  to="/admin/login"
                  onClick={closeMobileMenu}
                  className={({ isActive }) =>
                    `text-base font-medium py-2 px-4 rounded-lg transition-colors duration-200 ${
                      isActive
                        ? 'bg-primary-50 text-primary-600'
                        : 'text-secondary-700 hover:bg-secondary-50'
                    }`
                  }
                >
                  관리자
                </NavLink>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
